// src/data/copifyTestimonials.js
import FeedbackImg from "../assets/Testimonial_male.jpg";

const copifyTestimonials = [
  {
    name: "Rahul K.",
    badge: "+204%",
    text: "Turned a $400 test account into $1,220 in one week. The structure is consistent, predictable, and easy to follow.",
    image: FeedbackImg,
  },
  {
    name: "Amit U.",
    badge: "+118%",
    text: "Deposited $600 and finished the week above $1,300. Signal timing is sharp, and updates remove all second‑guessing.",
    image: FeedbackImg,
  },
  {
    name: "Vaibhav K.",
    badge: "+$480",
    text: "Made $480 in a single intraday session. Clear confirmations, controlled drawdown, and smooth execution.",
    image: FeedbackImg,
  },
  {
    name: "Abhijit C.",
    badge: "+163%",
    text: "Grew a $500 account to $1,315 within days. Setups are clean, risk is fixed, and every trade feels calculated.",
    image: FeedbackImg,
  },
  {
    name: "Sujit K.",
    badge: "+$560",
    text: "Earned $560 this week without overtrading. Entries are logical and momentum trades hit targets reliably.",
    image: FeedbackImg,
  },
  {
    name: "Pranav K.",
    badge: "+141%",
    text: "Turned $350 into $845 in three days. Strict risk rules keep losses small and winners consistently larger.",
    image: FeedbackImg,
  },
  {
    name: "Mahantesh A.",
    badge: "+$390",
    text: "Closed a session with $390 profit from one high‑conviction setup. Targets and alerts made execution effortless.",
    image: FeedbackImg,
  },
];

export default copifyTestimonials;
